// eslint-disable-next-line import/no-extraneous-dependencies
import { DeepPartial, type ApplePayPaymentRequests } from '@mangopay/checkout-sdk-core';

export const applePayDefaultOption: DeepPartial<ApplePayPaymentRequests> = {
  merchantCapabilities: ['supports3DS'],
  supportedNetworks: [
    'visa',
    'masterCard',
    'amex',
    'discover',
    'jcb',
    'interac',
    'maestro',
    'electron',
    'cartesBancaires',
    'girocard',
  ],
};
